import * as React from "react";

import { notify } from "@cayuse/shared-react.components.banner-notification";

import { NotificationMessage } from "components/NotificationMessage";

export const notifySuccess = (message, meta) => {
	notify(
		<NotificationMessage
			message={message}
			meta={meta}
		/>,
		{ type: "success" },
	);
};
